import { Toaster } from "@/components/ui/sonner";
import AnnouncementBar from "@/components/landing/AnnouncementBar";
import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import Visibility from "@/components/landing/Visibility";
import Services from "@/components/landing/Services";
import Methodology from "@/components/landing/Methodology";
import CaseStudies from "@/components/landing/CaseStudies";
import ClosingCTA from "@/components/landing/ClosingCTA";
import Footer from "@/components/landing/Footer";
import WhatsAppFAB from "@/components/landing/WhatsAppFAB";
import LeadFormFAB from "@/components/landing/LeadFormFAB";
import CustomiseScopeFAB from "@/components/landing/CustomiseScopeFAB";

export default function Landing() {
  return (
    <div data-testid="landing-page" className="relative">
      <AnnouncementBar />
      <Navbar />
      <main>
        <Hero />
        <Visibility />
        <Services />
        <Methodology />
        <CaseStudies />
        <ClosingCTA />
      </main>
      <Footer />
      <LeadFormFAB />
      <WhatsAppFAB />
      <CustomiseScopeFAB />
      <Toaster position="bottom-center" richColors />
    </div>
  );
}
